import script from "./RoomDetailSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDetailSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./RoomDetailSkeleton.vue?vue&type=style&index=0&id=681dbff1&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681dbff1"]])

export default __exports__